import APIService from '../../services/api'

import { getMapDataFromExhibition } from './resultmap.helper'

import {
  SEARCH_EXHIBITION_LIST,
  SEARCH_EXHIBITION_MAP,
  SEARCH_EXHIBITION_PERIOD,
  FETCH_RESULT_LIST,
  FETCH_RESULT_MAP,
  FETCH_RESULT_PERIOD,
  UPDATE_RESULT_LIST,
  UPDATE_RESULT_MAP,
  UPDATE_RESULT_PERIOD,
  ERROR_API,
  ITEMS_PER_PAGE_FOR_MAP_DISPLAY
} from './constants'

import { EXHIBITION, getFiltersComputed } from '../../services/filters'

export const actionsExhibition = {
  [SEARCH_EXHIBITION_LIST] ({commit, state},
  { value, order, page, direction, itemsPerPage, collection, begin, end, jsonFilters }) {
    commit(FETCH_RESULT_LIST)
    let filters = getFiltersComputed(
      EXHIBITION,
      [],
      { value, order, direction, page, itemsPerPage, collection, begin, end, jsonFilters }
    )

    APIService.searchExhibition({
      filters,
      transform: true,
      satisfy: 'all',
      order: {
        column: order || 'begin_year',
        direction: direction || 'ASC'
      },
      page: {
        number: page,
        itemsPerPage
      }
    }).then(json => {
      commit(UPDATE_RESULT_LIST, {
        results: json.visu_exhibition || [],
        total: json._results || 0
      })
    }).catch((err) => {
      commit(ERROR_API, {
        error: err
      })
    })
  },
  [SEARCH_EXHIBITION_MAP] ({commit, state},
    { value, collection, begin, end, jsonFilters }) {
    commit(FETCH_RESULT_MAP)
    let filters = getFiltersComputed(
      EXHIBITION,
      [{
        property: 'section_x',
        matchType: 'nis',
        value: null
      }],
      { value, collection, begin, end, jsonFilters }
    )

    APIService.searchExhibitionAddress({
      filters,
      transform: true,
      satisfy: 'all',
      order: {
        column: 'begin_year',
        direction: 'DESC'
      },
      page: {
        number: 1,
        itemsPerPage: ITEMS_PER_PAGE_FOR_MAP_DISPLAY
      },
      columns: [
        'id_exhibition',
        'exhibition_title',
        'city',
        'begin_year',
        'begin_date',
        'section_x',
        'section_y'
      ].join(',')
    }).then(json => {
      const results = getMapDataFromExhibition(json.visu_exhibition_address)
      commit(UPDATE_RESULT_MAP, {
        results: results,
        total: json._results || 0
      })
    }).catch((err) => {
      commit(ERROR_API, {
        error: err
      })
    })
  },
  [SEARCH_EXHIBITION_PERIOD] ({commit, state},
    { value, collection, jsonFilters }) {
    commit(FETCH_RESULT_PERIOD)
    let filters = getFiltersComputed(
      EXHIBITION,
      [],
      { value, collection, jsonFilters }
    )
    APIService.searchExhibition({
      filters,
      transform: true,
      satisfy: 'all',
      order: {
        column: 'begin_year',
        direction: 'ASC'
      },
      page: {
        number: 1,
        itemsPerPage: 1
      },
      columns: 'begin_year'
    }).then(jsonBegin => {
      APIService.searchExhibition({
        filters,
        transform: true,
        satisfy: 'all',
        order: {
          column: 'begin_year',
          direction: 'DESC'
        },
        page: {
          number: 1,
          itemsPerPage: 1
        },
        columns: 'begin_year'
      }).then(jsonEnd => {
        if (jsonBegin.visu_exhibition[0] && jsonEnd.visu_exhibition[0]) {
          commit(UPDATE_RESULT_PERIOD, {
            period: {
              begin: jsonBegin.visu_exhibition[0].begin_year + '-01-01',
              end: jsonEnd.visu_exhibition[0].begin_year + '-12-31'
            }
          })
        }
      })
    }).catch((err) => {
      commit(ERROR_API, {
        error: err
      })
    })
  }
}

export default actionsExhibition



// WEBPACK FOOTER //
// ./src/store/search/actions.exhibition.js